/* eslint-disable react/prop-types */
import { Box, Typography } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import TaxPersonalTable02 from "./components/table2";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import Footer from "./components/footer";
import Fields from "./components/field";
import ModalContent from "./components/modalContent";
import ModalCommon from "components/Modal";

export default function TaxPersonal13() {
  const { formId, formField } = form;
  const [open, setOpen] = React.useState(true);

  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ModalCommon open={open} setOpen={setOpen} content={<ModalContent />}>
        <Typography variant="subtitle1" color="red">
          Lưu ý: Nếu cá nhân đã có MST thì lập tờ khai riêng và bật ô &quot;Thay đổi thông tin
          ĐKT&quot;.
        </Typography>
        <Typography variant="subtitle1" color="red">
          Trường hợp cá nhân thay đổi thông tin &quot;Họ và tên&quot; thì không thực hiện thay đổi
          qua cơ quan chi trả, đề nghị cá nhân tự nộp hồ sơ thay đổi đến CQT
        </Typography>
        <Box display="flex" flexDirection="column" pb={10} gap={3} mt={2}>
          <Box textAlign="center">
            <Typography variant="h4" textTransform="uppercase">
              tờ khai đăng ký thuế tổng hợp người phụ thuộc của cá nhân có thu nhập tiền lương, tiền
              công
            </Typography>
            <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
              (Dùng cho cơ quan chi trả thu nhập đăng ký cho người phụ thuộc có ủy quyền)
            </Typography>
          </Box>
          <Formik
            initialValues={initialValues}
            validationSchema={validation}
            onSubmit={handleSubmit}
          >
            {({ values, errors, touched, isSubmitting, setFieldValue }) => (
              <Form id={formId} autoComplete="off">
                <Fields
                  formData={{
                    values,
                    errors,
                    touched,
                    formField,
                  }}
                />
                <TaxPersonalTable setFieldValue={setFieldValue} />
                <TaxPersonalTable02 setFieldValue={setFieldValue} />
                <Footer
                  formData={{
                    values,
                    errors,
                    touched,
                    formField,
                  }}
                />
                <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                  <SoftButton disabled={isSubmitting} type="submit" variant="gradient" color="dark">
                    {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                  </SoftButton>
                </SoftBox>
              </Form>
            )}
          </Formik>
        </Box>
      </ModalCommon>
    </DashboardLayout>
  );
}
